import React, { useState } from 'react';
import { Hospital, Building2, Mail, GraduationCap, Users, Briefcase } from 'lucide-react';
import BCMAnesthesiologyOverview from './BCMAnesthesiologyOverview';
import BCMAnesthesiologyContacts from './BCMAnesthesiologyContacts';
import BCMAnesthesiologyResidency from './BCMAnesthesiologyResidency';
import BCMAnesthesiologyFellowships from './BCMAnesthesiologyFellowships';
import BCMAnesthesiologyFaculty from './BCMAnesthesiologyFaculty';
import TabStrip from '../shared/TabStrip';
import ToolHeader from '../shared/ToolHeader';

export const DEPT_ACCENT = '#0369a1';

const TABS = [
  { id: 'overview', label: 'Overview', icon: Building2 },
  { id: 'contacts', label: 'Contacts', icon: Mail },
  { id: 'residency', label: 'Residency', icon: GraduationCap },
  { id: 'fellowships', label: 'Fellowships', icon: Users },
  { id: 'faculty', label: 'Faculty', icon: Briefcase },
];

const BCMAnesthesiologyScreen = ({ onBack, onTeeCertificationClick }) => {
  const [activeTab, setActiveTab] = useState('overview');
  return (
    <div className="max-w-md mx-auto bg-gray-50 dark:bg-gray-900 min-h-screen">
      <ToolHeader title="BCM Anesthesiology" subtitle="Department of Anesthesiology" icon={Hospital} accent={DEPT_ACCENT} backLabel="Home" onBack={onBack} />
      <TabStrip tabs={TABS} activeTab={activeTab} onChange={setActiveTab} activeClass="border-sky-700 dark:border-sky-400 text-sky-700 dark:text-sky-400" />
      <div className="p-6">
        {activeTab === 'overview' && <BCMAnesthesiologyOverview />}
        {activeTab === 'contacts' && <BCMAnesthesiologyContacts />}
        {activeTab === 'residency' && <BCMAnesthesiologyResidency onTeeClick={onTeeCertificationClick} />}
        {activeTab === 'fellowships' && <BCMAnesthesiologyFellowships />}
        {activeTab === 'faculty' && <BCMAnesthesiologyFaculty />}
      </div>
      <div className="h-8" />
    </div>
  );
};

export default BCMAnesthesiologyScreen;
